export type StructureDataValidationCode =
  | "invalid_json"
  | "empty"
  | "array_not_allowed"
  | "missing_context"
  | "missing_type";

export type StructureDataValidationResult =
  | { isValid: true }
  | { isValid: false; code: StructureDataValidationCode; detail?: string };

export const validateOverrideStructureData = (
  jsObject: any,
  hasParseError: boolean,
  parseErrorReason?: string,
): StructureDataValidationResult => {
  if (hasParseError) {
    return { isValid: false, code: "invalid_json", detail: parseErrorReason };
  }
  if (Array.isArray(jsObject)) {
    return { isValid: false, code: "array_not_allowed" };
  }
  if (jsObject === undefined || jsObject === null || Object.keys(jsObject).length === 0) {
    return { isValid: false, code: "empty" };
  }
  if (!jsObject["@context"]) {
    return { isValid: false, code: "missing_context" };
  }
  if (!jsObject["@type"]) {
    return { isValid: false, code: "missing_type" };
  }
  return { isValid: true };
};

export const getStructureDataErrorKey = (code: StructureDataValidationCode): string =>
  code === "missing_context" || code === "missing_type"
    ? "page_structure_data_missing_tags"
    : "page_structure_data_invalid_json";
